import _defineProperty from "/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genStepsRTLStyle = function genStepsRTLStyle(token) {
  var _$concat5;

  var componentCls = token.componentCls;
  return _defineProperty({}, "&".concat(componentCls, "-rtl"), (_$concat5 = {
    direction: 'rtl'
  }, _defineProperty(_$concat5, "".concat(componentCls, "-item"), {
    '&-subtitle': {
      float: 'left'
    }
  }), _defineProperty(_$concat5, "&".concat(componentCls, "-navigation"), _defineProperty({}, "".concat(componentCls, "-item::after"), {
    transform: 'rotate(-45deg)'
  })), _defineProperty(_$concat5, "&".concat(componentCls, "-vertical"), _defineProperty({}, "> ".concat(componentCls, "-item"), _defineProperty({
    '&::after': {
      transform: 'rotate(225deg)'
    }
  }, "".concat(componentCls, "-item-icon"), {
    float: 'right'
  }))), _defineProperty(_$concat5, "&".concat(componentCls, "-dot"), _defineProperty({}, "".concat(componentCls, "-item-icon ").concat(componentCls, "-icon-dot, &").concat(componentCls, "-small ").concat(componentCls, "-item-icon ").concat(componentCls, "-icon-dot"), {
    float: 'right'
  })), _$concat5));
};

export default genStepsRTLStyle;